import React, { useEffect } from 'react';
import { Box } from 'src/components/Box';
import { ContentWidth } from 'src/components/ContentWidth';
import { Layout } from 'src/components/Layout';
import { useNavigate } from '@reach/router';
//import NativeForms from 'native-forms-react';
const querystring = require('querystring');

export default function contact() {
    const navigate = useNavigate();
    let source = 'page';
    if (
        typeof window !== 'undefined' &&
        window.location &&
        window.location.search
    ) {
        const query = querystring.parse(
            window.location.search.split('?').join('')
        );

        if (query && query.source) {
            source = query.source;
        }
    }

    return (
        <Layout
            pageTitleFull="Contact Us | Audentio Community"
            siteDescription="Looking for help with your online community? Contact us."
        >
            <ContentWidth
                maxWidth="containers.header"
                backgroundColor="red"
                flexGrow="1"
            >
                {/* <NativeForms form="https://my.nativeforms.com/wSJhTS2lXPmZCc3tGdnx2dh1Db" /> */}
                <iframe
                    title="NativeForm"
                    src="https://my.nativeforms.com/wSJhTS2lXPmZCc3tGdnx2dh1Db"
                    width="100%"
                    height="850"
                ></iframe>
            </ContentWidth>
        </Layout>
    );
}
